"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCustomerSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
const tag_1 = require("./tag");
exports.BaseCustomerSchema = __1.BaseSchema.extend({
    store: __1.BaseSchema.pick({ id: true }),
    tags: tag_1.CustomerTagSchema.partial().required({ id: true }).array(),
    firstName: __1.ShortStringSchema.optional(),
    lastName: __1.ShortStringSchema.optional(),
    fullName: __1.ShortStringSchema.optional(),
    phone: __1.PhoneSchema,
    alternativePhone: __1.PhoneSchema.partial().optional(),
    email: __1.LongStringSchema.email().optional(),
    website: __1.LongStringSchema.url().optional(),
    profileImageUri: __1.LongStringSchema.url().optional(),
    notes: __1.LongStringSchema.optional(),
    socialNetworkUris: __1.SocialNetworkUrisSchema.optional(),
    dateOfBirth: zod_1.z
        .object({
        day: zod_1.z.number().min(1).max(31),
        month: zod_1.z.number().min(1).max(12),
        nearestBirthdayDate: zod_1.z.coerce.date().optional(),
        isBirthdayNear: zod_1.z.boolean().optional(),
    })
        .optional(),
    taxId: __1.ShortStringSchema.optional(),
    taxIdType: zod_1.z.nativeEnum(__1.TaxIdType).optional(),
    orderFrequency: zod_1.z.number().nonnegative().optional(),
    ordersCount: zod_1.z.number().nonnegative().optional(),
    source: zod_1.z.nativeEnum(__1.CustomerSource).optional(),
    platformSource: zod_1.z.nativeEnum(__1.CustomerPlatformSource).optional(),
});
//# sourceMappingURL=base-customer.js.map